'use strict';

class orderService {
  constructor($http) {
    this.$http = $http;
  }

  send(number, params) {
    return this.$http.post('/order-confirmation/drafts/' + number + '/issueSend', params);
  }

  sendAgain(number, params) {
    return this.$http.post('/order-confirmation/' + number + '/send', params);
  }

  /* STATS */
  getStatistics() {
    return this.$http.get('/order-confirmation/statistics');
  }

  getSent() {
    return this.$http.get('/order-confirmation/sent');
  }

  getCancelled() {
    return this.$http.get('/order-confirmation/cancelled');
  }

  getCompleted() {
    return this.$http.get('/order-confirmation/completed');
  }

  /* DRAFTS */
  getDrafts() {
    return this.$http.get('/order-confirmation/drafts');
  }

  getDraft(number) {
    return this.$http.get('/order-confirmation/drafts/' + number);
  }

  getOrderConfirmation(number) {
    return this.$http.get('/order-confirmation/' + number);
  }

  saveDraft(params) {
    return this.$http.post('/order-confirmation/drafts', params);
  }

  deleteDraft(number) {
    return this.$http.delete('/order-confirmation/drafts/' + number);
  }


  cancelDocument(number) {
    return this.$http.post('/order-confirmation/' + number + '/cancel');
  }

  getPdf(number) {
    return this.$http.get('/order-confirmation/' + number + '/pdf');
  }

  getViewInfo(number) {
    return this.$http.get('/order-confirmation/' + number + '/viewInfo');
  }

  getHistory(number) {
    return this.$http.get('/order-confirmation/' + number + '/history');
  }
}

orderService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('orderConfirmationService', orderService);
